/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_New_Share_ButtonInputs */



/**
* | output |
* | --- |
* | "New Share" |
*
* @param {Team_Share_New_Share_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_new_share_button = /** @type {((inputs?: Team_Share_New_Share_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_New_Share_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau partage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Aktie")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuova condivisione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новая акция")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva acción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新股")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいシェア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया शेयर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo Compartilhar")
	return /** @type {LocalizedString} */ ("New Share")
});